import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PagesPublicPlansPlanList } from '@web-kc/pages/cabinet/plans/plan-list';

export default PagesPublicPlansPlanList;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale = 'ru',
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? defaultLocale, [
        'common',
        'plans',
      ])),
    },
  };
};
